import { TIME_FORMAT } from '../constants';
const DATE_TIME_FORMAT = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
};
const FULL_DATE_TIME_FORMAT = Object.assign(Object.assign({}, DATE_TIME_FORMAT), { weekday: 'long', timeZoneName: 'short' });
export const formatDateTime = (timestamp, language, timeFormat, format = 'long') => {
    const options = format === 'full' ? FULL_DATE_TIME_FORMAT : DATE_TIME_FORMAT;
    return new Date(timestamp).toLocaleString(language, Object.assign(Object.assign({}, options), { hour12: timeFormat === TIME_FORMAT.TWELVE_HOURS }));
};
